import React from "react";
import { CategoryButtonProps } from "../../types/category-button";
import { VIEWPORT_BREAKPOINT_550 } from "../../constants";
import "./category-button.scss";

const CategoryButton = (props: CategoryButtonProps) => {
  const buttonTabNavAttribute = { focusable: true };

  const callToAction = () => {
    const prefix = props.l10nMore + " ";
    const defaultCallToAction = prefix + props.categoryName;

    // prevents multiline button for smallest viewport
    const viewPortWidth = document.documentElement.clientWidth;
    if (viewPortWidth <= VIEWPORT_BREAKPOINT_550 && defaultCallToAction.length > 17) {
      return props.l10nMoreProducts;
    }

    return defaultCallToAction;
  };

  return (
    <div className="category-link-button-container">
      <a
        className="prs-button category-link"
        data-testid={`prs-button-category-link-${props.slot}`}
        data-semantic-id="product-recommendation-button-category"
        data-product-recommendation-tile-index={props.slot}
        data-product-recommendation-fragment={props.dataFragmentName}
        data-product-recommendation-model={props.productRecoModel}
        href={props.categoryLink}
        {...buttonTabNavAttribute}
      >
        <span className="call-to-action">{callToAction()}</span>
      </a>
    </div>
  );
};

export default CategoryButton;
